import "../assets/css/footer.css";
import Couriel from "./comonents_footer/Couriel";
import Question from "./comonents_footer/Question";
import Information from "./comonents_footer/Information";
import Lien from "./comonents_footer/Lien";
import { FaMapMarkerAlt } from "react-icons/fa";
export default function Footer() {
    return (
        <div>
            <div className="container">
                <div className="question_courielle">
                    <Information />
                    <Couriel />
                    <p className="locatlisation">
                        <FaMapMarkerAlt className="map" />
                        GATINEAU/OTTAWA
                    </p>
                </div>
                <Lien />
            </div>
        </div>
    );
}
